import React from 'react';
import TableWithSummary from '../../../../../components/table/TableWithSummary';
import columns from './columns';
import { PRODUCT_LIST_TABLE_EMPTY_TEXT } from '../../../../../constants/service/app/productConstants';
import {
  PRODUCT_LIST_FILTER_OPTION_MODEL,
  PRODUCT_LIST_SORT_OPTION_MODEL,
} from '../../../../../store/modules/product/models';
import { LIST_PAGINATION_MODEL } from '../../../../../store/modules/app/models';

const ProductApprovalList = (props) => {
  const { productApprovalList, getList, getExcelDownload, getProductTagColumnTagList, getProductSubCategoryList } =
    props;
  const { list, filterOption, sortOption, pagination, summary } = productApprovalList;

  return (
    <div className="product-approval-list">
      <TableWithSummary
        data={list}
        totalCnt={summary.totalCnt}
        initialOption={{
          filterOption: PRODUCT_LIST_FILTER_OPTION_MODEL,
          sortOption: PRODUCT_LIST_SORT_OPTION_MODEL,
          pagination: LIST_PAGINATION_MODEL,
        }}
        isStriped={true}
        emptyText={PRODUCT_LIST_TABLE_EMPTY_TEXT}
        showPagination
        filterOption={filterOption}
        sortOption={sortOption}
        pagination={pagination}
        getList={getList}
        getExcelDownload={getExcelDownload}
        columns={(utils) =>
          columns({
            getProductTagColumnTagList,
            getProductSubCategoryList,
            ...utils,
          })
        }
      />
    </div>
  );
};

export default ProductApprovalList;
